module.exports = __webpack_public_path__ + "img/stock2.45f08048.png";